import {gql} from "@apollo/client";

export const resetStepUpFlowMutation = gql`
    mutation ResetStepUpFlow_Admin($customerId: String!) {
        resetStepUpFlow_Admin(customerId: $customerId)
    }
`